import styled from 'styled-components';
import ArrowSvg from '../../assets/mytrips/ic-arrowwhite.svg';

const ArrowIcon = styled(ArrowSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.4rem'};
  height: ${props => props.height || '4rem'};
  margin: ${props => props.margin};
`;

export default ArrowIcon;
